jQuery(function ($) {
  $(document).on("submit", "#activityForm", function (event) {
    event.preventDefault();

    // console.log("lets submit activity!");

    const $form = $(this);
    const $submitButton = $("#activitySubmitButton");
    const $loader = $("#loader-form");
    const $responseName = $("#responseMessageName");
    const $responseEmail = $("#responseMessageEmail");
    const $responseSuccess = $("#responseSuccess");
    const $modalTitleSuccess = $("#activity-modal-title");

    $responseName.html("");
    $responseEmail.html("");
    $responseSuccess.html("");

    $loader.addClass("active");
    $submitButton.prop("disabled", true);

    const formValues = {};
    $.each($form.serializeArray(), function (_, field) {
      if (formValues[field.name]) {
        if (Array.isArray(formValues[field.name])) {
          formValues[field.name].push(field.value);
        } else {
          formValues[field.name] = [formValues[field.name], field.value];
        }
      } else {
        formValues[field.name] = field.value;
      }
    });

    // console.log("values", formValues);

    $.get("/session/token")
      .done(function (csrfToken) {
        $.ajax({
          url: "/api/form/activity/submit",
          type: "POST",
          data: JSON.stringify(formValues),
          contentType: "application/json",
          headers: {
            "X-CSRF-Token": csrfToken
          },
          success: function () {
            $loader.removeClass("active");
            $submitButton.prop("disabled", false);
            $form.hide();
            $responseSuccess.html(
              '<div class="success">Wil je je toch afmelden voor deze activiteit? Dit kan per mail.</div>'
            );
            $modalTitleSuccess.text("Je bent aangemeld voor de activiteit");
          },
          error: function (error) {
            $loader.removeClass("active");
            $submitButton.prop("disabled", false);
            $responseSuccess.html(
              '<div class="error" tabindex="-1" role="alert">Submit failed.</div>'
            );
            console.error(error);
          }
        });
      })
      .fail(function () {
        $loader.removeClass("active");
        $submitButton.prop("disabled", false);
        $responseSuccess.html(
          '<div class="error" tabindex="-1" role="alert">Could not get CSRF token.</div>'
        );
      });

    return false;
  });

  const modalregisterActivity = $("#modal-registerActivity");

  function showDialogregisterActivity() {
    modalregisterActivity.addClass("show-modal");
    $("body").css("overflow", "hidden");
  }

  function closeDialogregisterActivity(refresh = false) {
    modalregisterActivity.removeClass("show-modal");
    $("body").css("overflow", "auto");

    if (refresh) {
      setTimeout(function () {
        window.location.reload();
      }, 200);
    }
  }

  function togglemodalregisterActivity() {
    if (modalregisterActivity.hasClass("show-modal")) {
      closeDialogregisterActivity(true);
    } else {
      closeDialog();
      showDialogregisterActivity();
    }
  }

  function windowOnClickregisterActivity(event) {
    if ($(event.target).is(modalregisterActivity)) {
      closeDialogregisterActivity(true);
    }
  }

  $(".close-registerActivity-button").on("click", function () {
    closeDialogregisterActivity(true);
  });

  $(window).on("click", windowOnClickregisterActivity);

  $(document).on("click", ".register-activity-trigger", function () {
    $('#activityForm input[name="registration_type"]').val("register");
    // console.log("open modal register activity");
    showDialogregisterActivity();
  });

  $(document).on("click", ".waitlist-activity-trigger", function () {
    $('#activityForm input[name="registration_type"]').val("waitlist");
    showDialogregisterActivity();
  });
});
